import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../styles/Header.css";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const el = document.documentElement;
      setScrolled(el.scrollTop > 30);
      setProgress((el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className={`header-shell${scrolled ? " header-scrolled" : ""}`}>
      <div className="mm-scroll-bar" style={{ width: `${progress}%` }} />
      <div className="header">
        <div className="logo">
          <NavLink to="/" className="logo-link">
            <img src="/assets/logo.png" alt="Macro Matrix Logo" />
            <div className="logo-text">
              <span className="macro">MACRO MATRIX</span>
              <br />
              <span className="matrix">(PVT) LIMITED</span>
            </div>
          </NavLink>
        </div>

        <div className="mobile-menu-icon" onClick={toggleMenu}>
          {!isOpen ? (
            <span className="menu-toggle-icon">&#9776;</span>
          ) : (
            <span className="menu-toggle-icon">&times;</span>
          )}
        </div>

        <nav className={`nav-menu ${isOpen ? "open" : ""}`}>
          <span className="nav-close-icon" onClick={toggleMenu}>
            &times;
          </span>
          <ul>
            <li>
              <NavLink
                to="/"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/company"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Company
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Services
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/portfolio"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Portfolio
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/apps"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Apps
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/reviews"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Reviews
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/careers"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Careers
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                onClick={toggleMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="header-action">
          <NavLink to="/contact" className="talk-button">
            Let's Talk
          </NavLink>
        </div>
      </div>
    </header>
  );
}

export default Header;
